import { notify } from 'utils/reduxUtils';

export const types = {
  CONTACT_DETAILS_INIT: 'contacts/contactDetails/CONTACT_DETAILS_INIT',
  DELETE_CONTACT_ERROR: 'contacts/contactDetails/DELETE_CONTACT_ERROR',
  DELETE_CONTACT_REQUEST: 'contacts/contactDetails/DELETE_CONTACT_REQUEST',
  DELETE_CONTACT_SUCCESS: 'contacts/contactDetails/DELETE_CONTACT_SUCCESS',
  FETCH_CONTACT_ERROR: 'contacts/contactDetails/FETCH_CONTACT_ERROR',
  FETCH_CONTACT_REQUEST: 'contacts/contactDetails/FETCH_CONTACT_REQUEST',
  FETCH_CONTACT_SUCCESS: 'contacts/contactDetails/FETCH_CONTACT_SUCCESS',
  UPDATE_CONTACTS_ACCOUNT_ERROR: 'contacts/contactDetails/REMOVE_ACCOUNT_ERROR',
  UPDATE_CONTACTS_ACCOUNT_REQUEST:
    'contacts/contactDetails/REMOVE_ACCOUNT_REQUEST',
  UPDATE_CONTACTS_ACCOUNT_SUCCESS:
    'contacts/contactDetails/REMOVE_ACCOUNT_SUCCESS',
  UPDATE_METADATA_ERROR: 'contacts/contactDetails/UPDATE_METADATA_ERROR',
  UPDATE_METADATA_REQUEST: 'contacts/contactDetails/UPDATE_METADATA_REQUEST',
  UPDATE_METADATA_SUCCESS: 'contacts/contactDetails/UPDATE_METADATA_SUCCESS',
};

export const contactDetails = {
  init: ({ contactId }) => ({
    type: types.CONTACT_DETAILS_INIT,
    payload: { contactId },
  }),
};

export const deleteContact = {
  error: notify(
    (error) => ({
      type: types.DELETE_CONTACT_ERROR,
      payload: error,
    }),
    'Failed to delete contact',
  ),
  request: () => ({
    type: types.DELETE_CONTACT_REQUEST,
  }),
  success: notify(
    () => ({
      type: types.DELETE_CONTACT_SUCCESS,
    }),
    'Successfully deleted contact',
  ),
};

export const fetchContact = {
  error: notify(
    (error) => ({
      type: types.FETCH_CONTACT_ERROR,
      payload: error,
    }),
    'Failed to load contact',
  ),
  request: () => ({
    type: types.FETCH_CONTACT_REQUEST,
  }),
  success: () => ({
    type: types.FETCH_CONTACT_SUCCESS,
  }),
};

export const updateContactsAccount = {
  error: notify(
    (error) => ({
      type: types.UPDATE_CONTACTS_ACCOUNT_ERROR,
      payload: error,
    }),
    'Failed to update contacts account',
  ),
  request: ({ accountId }) => ({
    type: types.UPDATE_CONTACTS_ACCOUNT_REQUEST,
    payload: { accountId },
  }),
  success: () => ({
    type: types.UPDATE_CONTACTS_ACCOUNT_SUCCESS,
  }),
};

export const updateMetadata = {
  error: notify(
    (error) => ({
      type: types.UPDATE_METADATA_ERROR,
      payload: error,
    }),
    'Failed to update metadata',
  ),
  request: ({ metadata }) => ({
    type: types.UPDATE_METADATA_REQUEST,
    payload: { metadata },
  }),
  success: notify(
    () => ({
      type: types.UPDATE_METADATA_SUCCESS,
    }),
    'Metadata updated.',
  ),
};
